import { EActionAttribute, EColor, EFontWeight, EIcon } from '@core/type';

import { Icon } from '../icon';
import { Box } from '../layout';
import { InputBorder } from './InputBorder';
import { InputHidden } from './InputHidden';
import { InputCheckboxProps } from './interface-input';

export const InputCheckboxBlueBordered = ({
  value: isChecked,
  label,
  ...inputProps
}: InputCheckboxProps) => (
  <Box
    as={EActionAttribute.LABEL}
    position={'relative'}
    flexShrink={0}
    flexGrow={1}
    borderRadius={'6px'}
    padding={'6px 16px'}
    minHeight={'48px'}
    display={'flex'}
    cursor={'pointer'}
  >
    <InputBorder
      borderColor={isChecked ? EColor.SECONDARY : EColor.PRIMARY}
      backgroundColor={
        isChecked
          ? EColor.INFO
          : {
              semanticType: EColor.INFO,
              variant: EColor.LIGHT,
            }
      }
    />
    <InputHidden<InputCheckboxProps> {...inputProps} type={'checkbox'} checked={isChecked} />
    <Box display={'flex'} alignItems={'center'} gap={'16px'} position={'relative'}>
      <Box
        position={'relative'}
        width={'20px'}
        height={'20px'}
        flexShrink={0}
        borderWidth={'1px'}
        borderStyle={'solid'}
        borderRadius={'4px'}
        aria-checked={isChecked}
        borderColor={isChecked ? EColor.SECONDARY : EColor.PRIMARY}
        backgroundColor={isChecked ? EColor.ACCENT : EColor.TRANSPARENT}
      >
        {isChecked && (
          <Icon
            type={EIcon.CHECK}
            color={{ commonType: EColor.WHITE, intensity: EColor.R900 }}
            strokeWidth="1.5"
            width={'18px'}
            height={'18px'}
            top={'0px'}
            left={'-1px'}
            position="absolute"
          />
        )}
      </Box>
      {label && (
        <Box
          fontSize={'16px'}
          display={'flex'}
          alignItems={'center'}
          color={isChecked ? EColor.ACCENT : EColor.PRIMARY}
          fontWeight={isChecked ? EFontWeight.BOLD : EFontWeight.REGULAR}
        >
          {label}
        </Box>
      )}
    </Box>
  </Box>
);
